import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
} from '@mui/material';
import { X } from 'react-feather';
import Card from '~/src/components/Card';
import InlineNotification from '~/src/components/Notification/InlineNotification';
import { LoadingSpinner } from '~/src/components/ClioDocumentPicker/LoadingSpinner';
import { useBusinessEntity } from '~/src/entities/subscription/hooks';
import { regional } from '~/src/regions/translations/regionalTranslations';

export const BusinessEntityCard = () => {
  const {
    error,
    loading,
    editLoading,
    showModal,
    viewIframeUrl,
    editIframeUrl,
    handleEdit,
    handleClose,
  } = useBusinessEntity();

  return (
    <>
      <Card>
        <div className="space-y-4">
          <div className="flex justify-between items-center">
            <h3 className="text-lg font-bold text-gray-900">
              {regional('businessInformationHeading')}
            </h3>
            <button
              onClick={handleEdit}
              disabled={editLoading}
              className="text-blue-600 hover:text-blue-700 font-medium text-sm disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {editLoading
                ? regional('businessInformationLoading')
                : regional('businessInformationEditButton')}
            </button>
          </div>

          {error && (
            <InlineNotification
              type="error"
              title={regional('businessInformationErrorTitle')}
              message={error}
            />
          )}

          {loading && <LoadingSpinner size="sm" />}

          {!loading && viewIframeUrl && (
            <div className="w-full overflow-hidden">
              <iframe
                src={viewIframeUrl}
                title={regional('businessInformationViewIframeTitle')}
                className="w-full border-0 h-[180px] overflow-hidden"
                sandbox="allow-same-origin allow-scripts allow-forms"
              />
            </div>
          )}
        </div>
      </Card>

      <Dialog
        open={showModal}
        onClose={handleClose}
        maxWidth={false}
        PaperProps={{ className: 'w-[700px] max-w-[90vw]' }}
      >
        <DialogTitle>
          <div className="flex justify-between items-center">
            <Typography variant="subheading">
              {regional('businessInformationModalTitle')}
            </Typography>
            <IconButton onClick={handleClose} size="small" aria-label="close">
              <X size={20} />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent dividers={false} className="p-2 border-t-0 border-b-0">
          {editIframeUrl && (
            <iframe
              src={editIframeUrl}
              title={regional('businessInformationEditIframeTitle')}
              className="w-full border-0 h-[260px]"
              sandbox="allow-same-origin allow-scripts allow-forms allow-popups"
            />
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};
